module.exports = __webpack_public_path__ + "img/icon-home-tp-03.a5fb657c.jpg";